import { FunctionComponent } from 'react';

const SigningOut: FunctionComponent = () => (
  <div className="text-center">
    <p>Signing out. Please wait.</p>
  </div>
);

export default SigningOut;
